import * as React from 'react';
import { useApi } from '../Api/useApi';
import { AddRemoveProjectToUserRequest, ProjectForAdminDto, ProjectsRycApiClient, UsersRycApiClient } from '../Api/ApiServer';
import { Box, Stack, Typography } from '@mui/material';
import ClickableCheckbox from '../Shared/ClickableCheckbox';
import SearchBox from '../Shared/SearchBox';

export interface IUserProjectAdminSelectProps {
    userId: number;
}

export default function UserProjectAdminSelect(props: IUserProjectAdminSelectProps) {
    const { userId } = props;
    const { authorizedApi } = useApi(ProjectsRycApiClient);
    const [projects, setProjects] = React.useState<ProjectForAdminDto[]>([]);
    const [visibleProjects, setVisibleProjects] = React.useState<ProjectForAdminDto[]>([]);
    const [searchTerm, setSearchTerm] = React.useState<string>('');
    const reloadProjectsForUser = React.useCallback(async () => {
        const projects = await authorizedApi?.projectsListAdmin(userId);
        setProjects(projects?.projects ?? []);
    }, [authorizedApi, userId]);
    React.useEffect(() => {
        reloadProjectsForUser();
    }, [reloadProjectsForUser]);
    React.useEffect(() => {
        if (searchTerm === '') setVisibleProjects(projects);
        else setVisibleProjects(projects.filter(p => p.name?.includes(searchTerm)));
    }, [projects, searchTerm]);
    const handleCheckboxChange = (projectId: number, checked: boolean) => {
        const updatedProjects = projects.map(p => p.id === projectId ? { ...p, choosed: checked } as ProjectForAdminDto : p);
        setProjects(updatedProjects);
        // setVisibleProjects(updatedProjects.filter(p => p.name?.includes(searchTerm)));
        authorizedApi?.addRemoveProjectUser(new AddRemoveProjectToUserRequest({ projectId, userId }));
    };
    return (
        <Stack  width={'100%'} alignItems={'start'}>
            <SearchBox sxWrap={{ width: '100%' }} fullWidth label='Hledat projekt' items={projects} onSearchChange={(query, items) => { setSearchTerm(query); }} propsToSearch={['name']} />
            {visibleProjects.map((project) => (
                <Box>
                    <ClickableCheckbox checked={project.choosed} onChange={(_, ch) => {
                        if (project.id)
                            handleCheckboxChange(project.id, ch)
                        // setProjects(projects.map(p => p.id === project.id ? { ...p, choosed: ch } as ProjectForAdminDto : p));
                        // authorizedApi?.addRemoveProjectUser(new AddRemoveProjectToUserRequest({ projectId: project.id, userId: userId }));
                    }} label={project.name} />

                </Box>
            ))}
        </Stack>
    );
}
